export default __webpack_public_path__ + "static/spela-pa-svenska-casino-med-bankid-dc046c5e8cca29e04afa305ea723c651.jpg";